import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { useSavingsStore } from '@/store/useSavingsStore'
import { useUserStore } from '@/store/useUserStore'
import { useGetSavingGoal, type WalletCurrency } from '@/domain'
import { currencyUtils } from '@/utils'

const { cryptoToBig, formatDynamicCurrency } = currencyUtils

export const TransferOutAvailableWalletAmount: React.FC = () => {
  const { t } = useTranslation()

  const goalTransferOut = useSavingsStore((s) => s.goalTransferOut)
  const setGoalTransferOut = useSavingsStore((s) => s.setGoalTransferOut)
  const completeCurrencies = useUserStore((s) => s.wallet?.completeCurrencies)

  // Находим USDT в кошельке пользователя для получения кода валюты
  const usdtWallet = completeCurrencies?.find(
    (currency: WalletCurrency) => currency.code === 'USDT',
  )

  // Получаем данные savings goal как в React Native
  const { data: savingGoal, isLoading: isLoadingSavingGoal } = useGetSavingGoal(
    {
      saving_goal_id: goalTransferOut.saving_goal_id,
    },
  )

  const handlePress = () => {
    if (isLoadingSavingGoal || !savingGoal) {
      return
    }

    // Используем staked_amount из savings goal, как в React Native
    const bigAmount = cryptoToBig({
      amount: savingGoal.staked_amount?.amount ?? '0',
    })

    setGoalTransferOut({
      isFiatMode: false, // Остаемся в crypto режиме при выборе максимума (как в других компонентах)
      cryptoAmount: {
        amount: bigAmount,
        code: usdtWallet?.code ?? 'USDT',
      },
      fiatAmount: {
        amount: savingGoal.staked_amount?.fiat_amount ?? '0',
        code: savingGoal.staked_amount?.fiat_currency || 'USD',
      },
    })
  }

  // Форматируем доступную сумму из savings goal (показываем даже если 0)
  const formattedAmount = formatDynamicCurrency({
    amount: savingGoal?.staked_amount?.amount ?? '0',
    currencyCode: usdtWallet?.code || 'USDT',
    showDecimals: true,
  })

  return (
    <BaseView
      center
      className="cursor-pointer hover:opacity-80 active:opacity-60 transition-opacity duration-150"
      onClick={handlePress}
      style={{
        padding: '8px 16px',
        borderRadius: '8px',
      }}
    >
      <BaseText
        fontSize={16}
        fontFamily="medium"
        color="label.clickable"
        textAlign="center"
      >
        Maximum: {formattedAmount}
      </BaseText>
    </BaseView>
  )
}
